import { render, staticRenderFns } from "./walker-sitter-modal.vue?vue&type=template&id=81b4a6ca&scoped=true&lang=pug"
import script from "./walker-sitter-modal.js?vue&type=script&lang=js&external"
export * from "./walker-sitter-modal.js?vue&type=script&lang=js&external"
import style0 from "./walker-sitter-modal.vue?vue&type=style&index=0&id=81b4a6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b4a6ca",
  null
  
)

export default component.exports